/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EmployeeRole } from '../api-models';
// @ts-ignore
import { LegacyConfigResponse } from '../api-models';
// @ts-ignore
import { OnboardingHealthStatus } from '../api-models';
// @ts-ignore
import { PaginatedResponseOfListOfFacilitySaasEmployeeCombinedView } from '../api-models';
// @ts-ignore
import { PaginatedResponseOfListOfSearchEmployeeHealthResponse } from '../api-models';
/**
 * AdminFacilityApi - axios parameter creator
 * @export
 */
export const AdminFacilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} databaseName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityConfigurationsDatabaseNameGet: async (databaseName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseName' is not null or undefined
            assertParamExists('adminFacilityConfigurationsDatabaseNameGet', 'databaseName', databaseName)
            const localVarPath = `/Admin/facility-configurations/{databaseName}`
                .replace(`{${"databaseName"}}`, encodeURIComponent(String(databaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [employeeId] 
         * @param {string} [loginId] 
         * @param {string} [phone] 
         * @param {string} [saasPhone] 
         * @param {string} [saasRole] 
         * @param {string} [role] 
         * @param {string} [saasUsername] 
         * @param {string} [otp] 
         * @param {boolean} [isOnboarded] 
         * @param {boolean} [isRegistered] 
         * @param {boolean} [isPhoneNumberConfirmed] 
         * @param {Array<string>} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdActiveEmployeesGet: async (facilityId: string, pageSize?: number, page?: number, firstName?: string, lastName?: string, employeeId?: string, loginId?: string, phone?: string, saasPhone?: string, saasRole?: string, role?: string, saasUsername?: string, otp?: string, isOnboarded?: boolean, isRegistered?: boolean, isPhoneNumberConfirmed?: boolean, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdActiveEmployeesGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/active-employees`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (loginId !== undefined) {
                localVarQueryParameter['loginId'] = loginId;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (saasPhone !== undefined) {
                localVarQueryParameter['saasPhone'] = saasPhone;
            }

            if (saasRole !== undefined) {
                localVarQueryParameter['saasRole'] = saasRole;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (saasUsername !== undefined) {
                localVarQueryParameter['saasUsername'] = saasUsername;
            }

            if (otp !== undefined) {
                localVarQueryParameter['otp'] = otp;
            }

            if (isOnboarded !== undefined) {
                localVarQueryParameter['isOnboarded'] = isOnboarded;
            }

            if (isRegistered !== undefined) {
                localVarQueryParameter['isRegistered'] = isRegistered;
            }

            if (isPhoneNumberConfirmed !== undefined) {
                localVarQueryParameter['isPhoneNumberConfirmed'] = isPhoneNumberConfirmed;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [databaseName] 
         * @param {EmployeeRole} [role] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [mobilePhone] 
         * @param {string} [employeeId] 
         * @param {string} [legacyLoginId] 
         * @param {OnboardingHealthStatus} [onboardingHealthStatus] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityPreProcessOnboardingGet: async (databaseName?: string, role?: EmployeeRole, firstName?: string, lastName?: string, mobilePhone?: string, employeeId?: string, legacyLoginId?: string, onboardingHealthStatus?: OnboardingHealthStatus, pageSize?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/facility/pre-process-onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseName !== undefined) {
                localVarQueryParameter['databaseName'] = databaseName;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }

            if (mobilePhone !== undefined) {
                localVarQueryParameter['mobilePhone'] = mobilePhone;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (legacyLoginId !== undefined) {
                localVarQueryParameter['legacyLoginId'] = legacyLoginId;
            }

            if (onboardingHealthStatus !== undefined) {
                localVarQueryParameter['onboardingHealthStatus'] = onboardingHealthStatus;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFacilityApi - functional programming interface
 * @export
 */
export const AdminFacilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFacilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} databaseName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityConfigurationsDatabaseNameGet(databaseName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityConfigurationsDatabaseNameGet(databaseName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [employeeId] 
         * @param {string} [loginId] 
         * @param {string} [phone] 
         * @param {string} [saasPhone] 
         * @param {string} [saasRole] 
         * @param {string} [role] 
         * @param {string} [saasUsername] 
         * @param {string} [otp] 
         * @param {boolean} [isOnboarded] 
         * @param {boolean} [isRegistered] 
         * @param {boolean} [isPhoneNumberConfirmed] 
         * @param {Array<string>} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdActiveEmployeesGet(facilityId: string, pageSize?: number, page?: number, firstName?: string, lastName?: string, employeeId?: string, loginId?: string, phone?: string, saasPhone?: string, saasRole?: string, role?: string, saasUsername?: string, otp?: string, isOnboarded?: boolean, isRegistered?: boolean, isPhoneNumberConfirmed?: boolean, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseOfListOfFacilitySaasEmployeeCombinedView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdActiveEmployeesGet(facilityId, pageSize, page, firstName, lastName, employeeId, loginId, phone, saasPhone, saasRole, role, saasUsername, otp, isOnboarded, isRegistered, isPhoneNumberConfirmed, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [databaseName] 
         * @param {EmployeeRole} [role] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [mobilePhone] 
         * @param {string} [employeeId] 
         * @param {string} [legacyLoginId] 
         * @param {OnboardingHealthStatus} [onboardingHealthStatus] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityPreProcessOnboardingGet(databaseName?: string, role?: EmployeeRole, firstName?: string, lastName?: string, mobilePhone?: string, employeeId?: string, legacyLoginId?: string, onboardingHealthStatus?: OnboardingHealthStatus, pageSize?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseOfListOfSearchEmployeeHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityPreProcessOnboardingGet(databaseName, role, firstName, lastName, mobilePhone, employeeId, legacyLoginId, onboardingHealthStatus, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminFacilityApi - factory interface
 * @export
 */
export const AdminFacilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFacilityApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityConfigurationsDatabaseNameGet(requestParameters: AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest, options?: AxiosRequestConfig): AxiosPromise<LegacyConfigResponse> {
            return localVarFp.adminFacilityConfigurationsDatabaseNameGet(requestParameters.databaseName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdActiveEmployeesGet(requestParameters: AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedResponseOfListOfFacilitySaasEmployeeCombinedView> {
            return localVarFp.adminFacilityFacilityIdActiveEmployeesGet(requestParameters.facilityId, requestParameters.pageSize, requestParameters.page, requestParameters.firstName, requestParameters.lastName, requestParameters.employeeId, requestParameters.loginId, requestParameters.phone, requestParameters.saasPhone, requestParameters.saasRole, requestParameters.role, requestParameters.saasUsername, requestParameters.otp, requestParameters.isOnboarded, requestParameters.isRegistered, requestParameters.isPhoneNumberConfirmed, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityPreProcessOnboardingGet(requestParameters: AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedResponseOfListOfSearchEmployeeHealthResponse> {
            return localVarFp.adminFacilityPreProcessOnboardingGet(requestParameters.databaseName, requestParameters.role, requestParameters.firstName, requestParameters.lastName, requestParameters.mobilePhone, requestParameters.employeeId, requestParameters.legacyLoginId, requestParameters.onboardingHealthStatus, requestParameters.pageSize, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminFacilityConfigurationsDatabaseNameGet operation in AdminFacilityApi.
 * @export
 * @interface AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest
 */
export interface AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGet
     */
    readonly databaseName: string
}

/**
 * Request parameters for adminFacilityFacilityIdActiveEmployeesGet operation in AdminFacilityApi.
 * @export
 * @interface AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest
 */
export interface AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly firstName?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly employeeId?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly loginId?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly phone?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly saasPhone?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly saasRole?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly role?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly saasUsername?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly otp?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly isOnboarded?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly isRegistered?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly isPhoneNumberConfirmed?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGet
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for adminFacilityPreProcessOnboardingGet operation in AdminFacilityApi.
 * @export
 * @interface AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest
 */
export interface AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly databaseName?: string

    /**
     * 
     * @type {EmployeeRole}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly role?: EmployeeRole

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly firstName?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly mobilePhone?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly employeeId?: string

    /**
     * 
     * @type {string}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly legacyLoginId?: string

    /**
     * 
     * @type {OnboardingHealthStatus}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly onboardingHealthStatus?: OnboardingHealthStatus

    /**
     * 
     * @type {number}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof AdminFacilityApiAdminFacilityPreProcessOnboardingGet
     */
    readonly page?: number
}

/**
 * AdminFacilityApi - object-oriented interface
 * @export
 * @class AdminFacilityApi
 * @extends {BaseAPI}
 */
export class AdminFacilityApi extends BaseAPI {
    /**
     * 
     * @param {AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFacilityApi
     */
    public adminFacilityConfigurationsDatabaseNameGet(requestParameters: AdminFacilityApiAdminFacilityConfigurationsDatabaseNameGetRequest, options?: AxiosRequestConfig) {
        return AdminFacilityApiFp(this.configuration).adminFacilityConfigurationsDatabaseNameGet(requestParameters.databaseName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFacilityApi
     */
    public adminFacilityFacilityIdActiveEmployeesGet(requestParameters: AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest, options?: AxiosRequestConfig) {
        return AdminFacilityApiFp(this.configuration).adminFacilityFacilityIdActiveEmployeesGet(requestParameters.facilityId, requestParameters.pageSize, requestParameters.page, requestParameters.firstName, requestParameters.lastName, requestParameters.employeeId, requestParameters.loginId, requestParameters.phone, requestParameters.saasPhone, requestParameters.saasRole, requestParameters.role, requestParameters.saasUsername, requestParameters.otp, requestParameters.isOnboarded, requestParameters.isRegistered, requestParameters.isPhoneNumberConfirmed, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFacilityApi
     */
    public adminFacilityPreProcessOnboardingGet(requestParameters: AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminFacilityApiFp(this.configuration).adminFacilityPreProcessOnboardingGet(requestParameters.databaseName, requestParameters.role, requestParameters.firstName, requestParameters.lastName, requestParameters.mobilePhone, requestParameters.employeeId, requestParameters.legacyLoginId, requestParameters.onboardingHealthStatus, requestParameters.pageSize, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}
